import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import { consumeTheme } from '../../utils/theme';
import { castInto, emptyFn, nullFn } from '../../utils/helper';
import { decideKeepDom } from '../../utils/keepDom';
import { downloadImage } from './util';
import LoadableImage from './LoadableImage';
import { DEFAULT_MIN_SCALE, PREVIEW_CLOSE_GAP_DURATION, SCALE_STEP, PREVIEW_TRANSITION_DURATION } from './constant';
import { toggleGlobalScrollEvents } from '../../utils/preventScrollPenetrate';
var Preview = (function (_super) {
    __extends(Preview, _super);
    function Preview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.minScale = DEFAULT_MIN_SCALE;
        _this.adaptScale = 1;
        _this.timer = new Date();
        _this.rootDomRef = React.createRef();
        _this.state = {
            currentIndex: _this.props.initialIndex,
            isWidgetsVisible: true,
            isForceHover: false,
            scaleUpDisable: false,
            scaleDownDisable: false,
            showFitScreenButton: false,
            showActualSizeButton: false,
            scale: 1,
        };
        _this.handleImageLoad = function () {
            _this.setState({
                isForceHover: true,
            });
            if (_this.clearForceHoverTimeout) {
                clearTimeout(_this.clearForceHoverTimeout);
                _this.clearForceHoverTimeout = null;
            }
            _this.clearForceHoverTimeout = setTimeout(function () {
                _this.setState({
                    isForceHover: false
                });
                _this.clearForceHoverTimeout = null;
            }, 3000);
        };
        _this.handleScale = function (targetScale, adaptScale, minScale) {
            if (minScale === void 0) { minScale = _this.minScale; }
            var maxScale = _this.props.maxScale;
            var scale = castInto(targetScale, [minScale, maxScale]);
            if (adaptScale) {
                _this.adaptScale = adaptScale;
            }
            _this.minScale = minScale;
            _this.setState({
                showActualSizeButton: scale !== 1,
                showFitScreenButton: scale !== _this.adaptScale,
                scale: scale,
            });
            if (scale >= maxScale) {
                _this.setState({ scaleUpDisable: true });
            }
            else if (scale <= minScale) {
                _this.setState({ scaleDownDisable: true });
            }
            else {
                _this.setState({ scaleUpDisable: false, scaleDownDisable: false });
            }
        };
        _this.handleKeyDown = function (e) {
            if (!_this.props.visible || /input|textarea/i.test(e.target.tagName)) {
                return;
            }
            if (['ArrowLeft', 'Left', 'a', 'h'].includes(e.key)) {
                _this.prevPage();
            }
            else if (['ArrowRight', 'Right', 'd', 'l'].includes(e.key)) {
                _this.nextPage();
            }
            else if (['-', 'ArrowDown', 'Down', 's', 'j'].includes(e.key)) {
                _this.scaleImageDown();
            }
            else if (['=', '+', 'ArrowUp', 'Up', 'w', 'k'].includes(e.key)) {
                _this.scaleImageUp();
            }
            else if (['0'].includes(e.key)) {
                _this.handleScale(1);
            }
            else if (['1'].includes(e.key)) {
                _this.realScreenShow();
            }
            else if (['Escape', 'Esc', 'q'].includes(e.key)) {
                _this.requestClose();
            }
        };
        _this.prevPage = function () {
            var length = _this.imageList.length;
            if (_this.canGoPrevPage()) {
                _this.updateCurrentPage((_this.state.currentIndex - 1 + length) % length);
                _this.setState({ showFitScreenButton: false });
            }
        };
        _this.nextPage = function () {
            var length = _this.imageList.length;
            if (_this.canGoNextPage()) {
                _this.updateCurrentPage((_this.state.currentIndex + 1) % length);
                _this.setState({ showFitScreenButton: false });
            }
        };
        _this.requestClose = function () {
            if (new Date().getTime() - _this.timer.getTime() <= PREVIEW_CLOSE_GAP_DURATION) {
                return;
            }
            _this.props.onClose();
        };
        _this.scaleImageUp = function () {
            _this.handleScale(_this.state.scale + SCALE_STEP);
        };
        _this.scaleImageDown = function () {
            _this.handleScale(_this.state.scale - SCALE_STEP);
        };
        _this.adaptScreen = function () {
            _this.handleScale(_this.adaptScale);
        };
        _this.realScreenShow = function () {
            var showActualSizeButton = _this.state.showActualSizeButton;
            if (!showActualSizeButton)
                return;
            _this.handleScale(1);
        };
        _this.downloadCurrentImage = function () {
            var currentIndex = _this.state.currentIndex;
            var onDownload = _this.props.onDownload;
            var downloadResult = onDownload(_this.getImageInfo(currentIndex), currentIndex);
            if (downloadResult === false) {
                return;
            }
            var fileName = downloadResult || 'image';
            downloadImage(_this.getUrl(currentIndex), fileName, _this.getClipStyle(currentIndex));
        };
        _this.handleError = function (e) {
            var currentIndex = _this.state.currentIndex;
            var onError = _this.props.onError;
            onError === null || onError === void 0 ? void 0 : onError(e, _this.getImageInfo(currentIndex), currentIndex);
        };
        _this.themedRender = function (classNames) {
            var _a, _b;
            var _c = _this.props, visible = _c.visible, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, maskStyle = _c.maskStyle, safeAreaInset = _c.safeAreaInset, containerDom = _c.containerDom, zIndex = _c.zIndex, maxScale = _c.maxScale, testId = _c.testId, embedded = _c.embedded;
            var _d = _this.state, currentIndex = _d.currentIndex, scale = _d.scale;
            if (!decideKeepDom.call(_this, PREVIEW_TRANSITION_DURATION, visible)) {
                return null;
            }
            var classes = classNames(prefixCls, className, prefixCls + "-" + (visible ? 'visible' : 'hidden'), (_a = {},
                _a[prefixCls + "-embedded"] = embedded,
                _a));
            var maskClass = classNames(prefixCls + "-image-mask", (_b = {},
                _b[prefixCls + "-image-mask-embedded"] = embedded,
                _b));
            var initialCoordinateStyle = _this.getInitialCoordinateStyle();
            var content = (h("div", { className: classes, style: __assign({ zIndex: zIndex }, style), "data-testid": testId, ref: _this.rootDomRef },
                h("div", { className: maskClass, style: maskStyle, onClick: _this.requestClose }),
                h(LoadableImage, { style: initialCoordinateStyle, url: _this.getUrl(currentIndex), preloadUrls: [_this.getUrl(currentIndex - 1), _this.getUrl(currentIndex + 1)], previewUrl: _this.getPreviewUrl(currentIndex), clipStyle: _this.getClipStyle(currentIndex), rotateDegree: _this.getRotateDegree(currentIndex), onContextMenu: function (e) { return _this.props.onContextMenu(e, currentIndex); }, onLoad: _this.handleImageLoad, onError: _this.handleError, maxScale: maxScale, scale: scale, onScaleChange: _this.handleScale, rootDomRef: _this.rootDomRef, safeAreaInset: safeAreaInset }),
                _this.renderHotZone(classNames)));
            if (embedded) {
                return content;
            }
            return ReactDOM.createPortal(content, containerDom || document.body);
        };
        return _this;
    }
    Preview.getDerivedStateFromProps = function (props) {
        if (typeof props.index === 'number') {
            return { currentIndex: props.index };
        }
        return null;
    };
    Preview.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.handleKeyDown);
        this.timer = new Date();
        this.setPreventGlobalScrollEvents(this.props.visible);
    };
    Preview.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.setPreventGlobalScrollEvents(this.props.visible);
        if (!prevProps.visible && this.props.visible) {
            this.timer = new Date();
            if (typeof this.props.index !== 'number') {
                this.updateCurrentPage(this.props.initialIndex);
                return;
            }
        }
        if (this.getImageList(prevProps).length !== this.imageList.length) {
            this.updateCurrentPage();
        }
    };
    Preview.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.handleKeyDown);
        this.setPreventGlobalScrollEvents(false);
        clearTimeout(this.clearForceHoverTimeout);
    };
    Object.defineProperty(Preview.prototype, "imageList", {
        get: function () {
            return this.getImageList(this.props);
        },
        enumerable: false,
        configurable: true
    });
    Preview.prototype.getImageList = function (props) {
        var urlList = props.urlList, images = props.images;
        return images || urlList || [];
    };
    Preview.prototype.getImageInfo = function (index) {
        if (this.props.images) {
            return this.props.images[index];
        }
        return {
            url: this.getUrl(index),
            clipStyle: this.getClipStyle(index),
            previewUrl: this.getPreviewUrl(index),
            rotateDegree: this.getRotateDegree(index),
        };
    };
    Preview.prototype.getUrl = function (index) {
        var _a;
        var _b = this.props, urlList = _b.urlList, images = _b.images;
        return ((_a = images === null || images === void 0 ? void 0 : images[index]) === null || _a === void 0 ? void 0 : _a.url) || (urlList === null || urlList === void 0 ? void 0 : urlList[index]);
    };
    Preview.prototype.getClipStyle = function (index) {
        var _a;
        var _b = this.props, imageClipStyle = _b.imageClipStyle, images = _b.images;
        return ((_a = images === null || images === void 0 ? void 0 : images[index]) === null || _a === void 0 ? void 0 : _a.clipStyle) || (imageClipStyle === null || imageClipStyle === void 0 ? void 0 : imageClipStyle[index]);
    };
    Preview.prototype.getRotateDegree = function (index) {
        var _a;
        var _b = this.props, rotateStyle = _b.rotateStyle, images = _b.images;
        return ((_a = images === null || images === void 0 ? void 0 : images[index]) === null || _a === void 0 ? void 0 : _a.rotateDegree) || (rotateStyle === null || rotateStyle === void 0 ? void 0 : rotateStyle[index]);
    };
    Preview.prototype.getPreviewUrl = function (index) {
        var _a;
        var _b = this.props, previewList = _b.previewList, images = _b.images;
        return ((_a = images === null || images === void 0 ? void 0 : images[index]) === null || _a === void 0 ? void 0 : _a.previewUrl) || (previewList === null || previewList === void 0 ? void 0 : previewList[index]);
    };
    Preview.prototype.canGoPrevPage = function () {
        var cycle = this.props.cycle;
        var currentIndex = this.state.currentIndex;
        return (this.imageList.length > 1 && cycle) || currentIndex > 0;
    };
    Preview.prototype.canGoNextPage = function () {
        var cycle = this.props.cycle;
        var currentIndex = this.state.currentIndex;
        return (this.imageList.length > 1 && cycle) || currentIndex < this.imageList.length - 1;
    };
    Preview.prototype.setPreventGlobalScrollEvents = function (prevent) {
        if (prevent === void 0) { prevent = true; }
        if (this.props.embedded) {
            return;
        }
        toggleGlobalScrollEvents(prevent);
    };
    Preview.prototype.updateCurrentPage = function (pageIndex) {
        if (pageIndex === void 0) { pageIndex = this.state.currentIndex; }
        if (!this.imageList.length) {
            this.requestClose();
        }
        var index = Math.max(0, Math.min(pageIndex, this.imageList.length - 1));
        if (index === this.state.currentIndex) {
            return;
        }
        this.setState({ currentIndex: index });
        this.props.onChange(index);
    };
    Preview.prototype.shouldShowDefaultBottomWidgets = function () {
        var _a = this.props, showBottomControl = _a.showBottomControl, renderBottomWidgets = _a.renderBottomWidgets;
        if (renderBottomWidgets)
            return false;
        if (showBottomControl)
            return true;
        return false;
    };
    Preview.prototype.getInitialCoordinateStyle = function () {
        var initialCoordinateStyle = {
            transform: 'scale(0)',
            '--init-coord': 'scale(0)'
        };
        if (this.props.initialCoordinate) {
            var width = window.innerWidth;
            var height = window.innerHeight;
            var left = this.props.initialCoordinate.left - (width / 2);
            var top_1 = this.props.initialCoordinate.top - (height / 2);
            initialCoordinateStyle = {
                transform: "translate(" + left + "px, " + top_1 + "px) scale(0.5)",
            };
            var initialIndex = this.props.initialIndex === undefined ? 0 : this.props.initialIndex;
            if (initialIndex === this.state.currentIndex) {
                initialCoordinateStyle['--init-coord'] = "translate(" + left + "px, " + top_1 + "px) scale(0.5)";
            }
            else {
                initialCoordinateStyle['--init-coord'] = "scale(0)";
            }
        }
        return initialCoordinateStyle;
    };
    Preview.prototype.renderDefaultBottomWidgets = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, renderMiddleButtons = _a.renderMiddleButtons, renderExtraButtons = _a.renderExtraButtons, disableDownload = _a.disableDownload;
        var _b = this.state, currentIndex = _b.currentIndex, scaleUpDisable = _b.scaleUpDisable, scaleDownDisable = _b.scaleDownDisable, showActualSizeButton = _b.showActualSizeButton, isWidgetsVisible = _b.isWidgetsVisible, showFitScreenButton = _b.showFitScreenButton;
        var scaleDownButtonClass = classNames(prefixCls + "-bar-button", prefixCls + "-scale-down-button", scaleDownDisable ? prefixCls + "-disable-click" : '');
        var scaleUpButtonClass = classNames(prefixCls + "-bar-button", prefixCls + "-scale-up-button", scaleUpDisable ? prefixCls + "-disable-click" : '');
        var adaptScreenButtonClass = classNames(prefixCls + "-bar-button", prefixCls + "-adapt-screen-button");
        var realScreenButtonClass = classNames(prefixCls + "-bar-button", prefixCls + "-real-screen-button", showActualSizeButton ? '' : prefixCls + "-disable-click");
        var downloadButtonClass = classNames(prefixCls + "-bar-button", prefixCls + "-download-button");
        var bottomButtonWidgetsContainerClasses = classNames(prefixCls + "-widgets-button-container-bottom", prefixCls + "-widgets-button-container-" + (isWidgetsVisible ? 'visible' : 'hidden'));
        var divideLine = classNames(prefixCls + "-divide-line");
        return (h("div", { className: bottomButtonWidgetsContainerClasses },
            h("span", { className: scaleUpButtonClass, onClick: this.scaleImageUp }),
            h("span", { className: scaleDownButtonClass, onClick: this.scaleImageDown }),
            showFitScreenButton
                ? h("span", { className: adaptScreenButtonClass, onClick: this.adaptScreen })
                : h("span", { className: realScreenButtonClass, onClick: this.realScreenShow }),
            renderMiddleButtons(currentIndex),
            !disableDownload && h(React.Fragment, null,
                h("span", { className: divideLine }),
                h("span", { className: downloadButtonClass, onClick: this.downloadCurrentImage })),
            renderExtraButtons(currentIndex)));
    };
    Preview.prototype.renderTopArea = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, renderTopWidgets = _a.renderTopWidgets, embedded = _a.embedded, renderTitleBar = _a.renderTitleBar;
        var _b = this.state, currentIndex = _b.currentIndex, isWidgetsVisible = _b.isWidgetsVisible;
        var closeButtonClass = classNames(prefixCls + "-button-close");
        var topWidgetsContainerClasses = classNames(prefixCls + "-widgets-container", prefixCls + "-widgets-container-top", prefixCls + "-widgets-container-" + (isWidgetsVisible ? 'visible' : 'hidden'));
        return (renderTitleBar
            ? renderTitleBar(currentIndex)
            : h("div", { className: topWidgetsContainerClasses },
                renderTopWidgets(currentIndex),
                !embedded && h("div", { className: closeButtonClass, onClick: this.requestClose })));
    };
    Preview.prototype.renderHotZone = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, showPageNumber = _a.showPageNumber, renderBottomWidgets = _a.renderBottomWidgets;
        var _b = this.state, currentIndex = _b.currentIndex, isWidgetsVisible = _b.isWidgetsVisible, isForceHover = _b.isForceHover;
        var shouldShowBottomButton = this.shouldShowDefaultBottomWidgets();
        var hotZoneClasses = classNames(prefixCls + "-hot-zone", isForceHover ? prefixCls + "-force-hover" : '');
        var prevButtonClass = classNames(prefixCls + "-side-button", prefixCls + "-button-prev");
        var nextButtonClass = classNames(prefixCls + "-side-button", prefixCls + "-button-next");
        var bottomWidgetsContainerClasses = classNames(prefixCls + "-widgets-container", prefixCls + "-widgets-container-bottom", prefixCls + "-widgets-container-" + (isWidgetsVisible ? 'visible' : 'hidden'));
        var pageNumberClasses = classNames(prefixCls + "-page-number", prefixCls + "-page-number-" + (isWidgetsVisible ? 'visible' : 'hidden'));
        var bottomContainer = classNames(prefixCls + "-bottom-container");
        return (h("div", { className: hotZoneClasses },
            this.renderTopArea(classNames),
            this.canGoPrevPage() && h("div", { className: prevButtonClass, onClick: this.prevPage }),
            this.canGoNextPage() && h("div", { className: nextButtonClass, onClick: this.nextPage }),
            h("div", { className: bottomContainer },
                showPageNumber && this.imageList.length > 1 && h("div", { className: pageNumberClasses },
                    currentIndex + 1,
                    "/",
                    this.imageList.length),
                shouldShowBottomButton
                    ? this.renderDefaultBottomWidgets(classNames)
                    : h("div", { className: bottomWidgetsContainerClasses }, renderBottomWidgets(currentIndex)))));
    };
    Preview.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    return Preview;
}(React.Component));
export default Preview;
Preview.defaultProps = {
    prefixCls: 'dui-preview',
    visible: true,
    initialIndex: 0,
    showPageNumber: true,
    maxScale: 5,
    onChange: emptyFn,
    onContextMenu: emptyFn,
    onClose: emptyFn,
    showBottomControl: true,
    containerDom: typeof document !== 'undefined' ? document.body : undefined,
    cycle: false,
    disableDownload: false,
    renderExtraButtons: nullFn,
    renderTopWidgets: nullFn,
    renderMiddleButtons: nullFn,
    embedded: false,
    onDownload: emptyFn,
    safeAreaInset: 48,
};
